
import { createFileRoute } from "@tanstack/react-router";
import DirectPage from "../../components/Direct/DirectPage.tsx"

export const Route = createFileRoute("/_layout/direct")({
    component: DirectPage,
});

